__webpack_require__.p = "/bot/chain/";